var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"settings-center-rail"},[(_vm.settingsNavSelected == 'call-log')?_c('call-log'):_vm._e(),(_vm.settingsNavSelected == 'call-uniq-cust')?_c('unique-customers'):_vm._e(),(
      [
        'telecom-fwd',
        'telecom-trck',
        'telecom-flow',
        'telecom-block'
      ].includes(_vm.settingsNavSelected)
    )?_c('telecom-settings',{ref:"telecom-pane"}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }